import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useFormik } from 'formik';
// @mui
import {
  Stack,
  IconButton,
  InputAdornment,
  Dialog,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  OutlinedInput,
  Button,
  TextField,
} from '@mui/material';
import { message, notification } from 'antd';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { SmileOutlined } from '@ant-design/icons';
import { LoadingButton } from '@mui/lab';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
// components
import axios from 'axios';
import { set } from 'lodash';
import { getToken } from 'src/utils/common';

export default function Reset() {
  const history = useNavigate();
  const username = useFormInput('');
  const password = useFormInput('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [error, setError] = useState(null);
  const [error3, setError3] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newemail, setnewemail] = useState('');
  const [newfullname, setNewFullname] = useState('');
  const [newphone, setnewphone] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorphone, setErrorPhone] = useState('');
  const [errorText, setErrorText] = useState('');
  const [errorText2, setErrorText2] = useState('');
  const [errorTextEmail, setErrorTextEmail] = useState('');
  const [errorTextFname, setErrorTextFname] = useState('');
  const [password2, setPassword] = useState('');
  const [accesstoken, setaccesstoken] = useState('');
  const [refreshtoken, setrefreshtoken] = useState('');
  const [loadings, setloading] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isDeleteOpen, setisDeleteOpen] = useState(false);
  const handleTogglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };
  const handleTogglePasswordVisibilities = () => {
    setShowPassword(!showPassword);
  };
  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);

    // Validate against the regex pattern
    const regexPattern = /^(?=.*[A-Z])(?=.*\d).{7,}$/;
    if (!regexPattern.test(newPassword)) {
      setErrorText('Password must be at least 7 characters long and contain an uppercase letter, a number.');
    } else {
      setErrorText('');
    }
    if (newPassword !== confirmPassword) {
      setErrorText2('Password must be same with Confirm Password');
    } else {
      setErrorText2('');
    }
  };

  const handlePhoneChange = (event) => {
    const phoneValue = event.target.value;

    // Remove non-numeric characters from the input
    const numericValue = phoneValue.replace(/\D/g, ''); // Replace any non-numeric characters

    if (numericValue.length === 0) {
      setErrorPhone('Phone number is required');
    } else if (numericValue.length < 10) {
      setErrorPhone('Phone number must be at least 10 digits long');
    } else {
      setErrorPhone(''); // No error
    }
    setnewphone(numericValue);
  };

  function extractNameFromEmail(emailFromURL) {
    const emailParts = emailFromURL?.split('@');
    if (emailParts?.length === 2) {
      return emailParts[0];
    }
    return '';
  }

  useEffect(() => {
    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(currentUrl);
    const emailFromURL = urlParams.get('token');

    const decodedEmail = atob(emailFromURL);

    const extractedName = extractNameFromEmail(decodedEmail);
    setName(extractedName);
  }, []);

  function extractNameAndEmailFromURL(url) {
    const urlParams = new URLSearchParams(url);
    const emailFromURL = urlParams.get('token');
    const decodedEmail = atob(emailFromURL);
    return { email: decodedEmail };
  }

  useEffect(() => {
    const currentUrl = window.location.href;
    const { email: extractedEmail } = extractNameAndEmailFromURL(currentUrl);

    setEmail(extractedEmail);
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Access the 'token' parameter from the URL
  const token = searchParams.get('token');

  const handleConfirmPasswordChange = (event) => {
    const newConfirmPassword = event.target.value;
    setConfirmPassword(newConfirmPassword);

    // Check if confirm password matches password
    if (newConfirmPassword !== password2) {
      setErrorText2('Passwords do not match.');
    } else {
      setErrorText2('');
    }
  };

  const handleEmailChange = (e) => {
    setnewemail(e.target.value);
    setnewemail(newemail);

    const regexPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!regexPattern.test(newemail)) {
      setErrorTextEmail('Please enter the correct Email.');
    } else {
      setErrorTextEmail('');
    }
  };

  const handleFullnameChange = (event) => {
    const newValue = event.target.value;
    setNewFullname(newValue);

    // Check if the field is empty and update the error message accordingly.
    if (newValue.trim() === '') {
      setErrorTextFname('Full Name cannot be empty');
    } else {
      setErrorTextFname('');
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleUserNameChange = (event) => {
    const newName = event.target.value;
    setName(newName);

    // Validate the username
    if (newName.trim() === '') {
      setError3('Username cannot be empty');
    } else {
      setError3('');
    }
  };

  const handleSubmit = async (event) => {
    setloading(true);
    event.preventDefault();
    // Perform additional actions here, like submitting the password
    const formData = {
      Password: password2,
      token,
    };

    // Define the API endpoint URL
    const apiUrl = window.REACT_APP_API_PURE + 'user/password/reset';

    // Set up the request headers with the Bearer Token and Content-Type
    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken}`,
    });

    // Create the request options
    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData), // Convert the form data to JSON
    };

    // Send a POST request to the API with the form data, Bearer Token, and Content-Type in the headers
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          notification.error({
            message: 'Error',
            description:  t('Password can`t be changed'),  
            placement: 'top', 
            duration: 0, 
             
          })
        } else {
          notification.success({
            message: 'Success',
            description:  ('Password changed successfully'),
            placement: 'top', 
            duration: 0, 
             
          })
          setTimeout(() => {
            history('/login');
          }, 2000);
        }
      })
      .then((response) => {
        // Handle the API response here
        // if (data.response_code === 200) {
        //   alert('Success Reset Password');
        //   // Assuming 'history' is a function to navigate to another page, you need to invoke it correctly
        //   history('/login');
        // } else {
        //   alert('Failed to reset the password');
        // }
      })
      .catch((error) => {
        setloading(false);
        // Handle any errors that occur during the request
        console.error('Error:', error);
      });
  };

  const handleCloseDeleteModalder = () => {
    setisDeleteOpen(false);
  };
  const handleOpenDeleteModalder = () => {
    setisDeleteOpen(true);
  };

  function DialogDelete() {
    return (
      <Dialog open={isDeleteOpen} onClose={handleCloseDeleteModalder}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>Password has been change!</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteModalder}>Confirm</Button>
        </DialogActions>
      </Dialog>
    );
  }
  return (
    <form onSubmit={handleSubmit}>
      <section className="z-0 w-full h-screen bg-center bg-local bg-cover bg-dunes">
        <div className="z-100 container mx-auto px-4 h-screen">
          <div className="flex  content-center items-center justify-center h-screen">
            <div className="w-full lg:w-9/12 px-4">
              <div
                className="relative flex flex-col items-center min-w-0 break-words w-full mb-6 shadow-2xl shadow-blue-500/50 rounded-lg bg-blueGray-200 border-0"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 1)', // You can adjust the background color and opacity here
                }}
              >
                <Grid container direction={'row'} alignItems="stretch">
                  <Grid
                    xs={12}
                    item
                    md={6}
                    style={{
                      // backgroundColor: '',
                      backgroundImage: 'url(/assets/Frame1.png)',
                      backgroundSize: 'cover', // Adjust this as needed
                      backgroundPosition: 'center', // Adjust this as needed
                      height: 'screen',
                    }}
                  >
                    {''}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    style={{
                      height: '100vh',
                      paddingTop: '20vh',
                      backgroundSize: 'cover',
                      paddingRight: 60,
                      paddingLeft: 60,
                    }}
                    textAlign={'center'}
                  >
                    {DialogDelete()}
                    <Grid container direction={'row'} spacing={1}>
                      <Grid item xs={12}>
                        <Typography variant="h3">Reset Password</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography align="start" variant="body2">
                          Password
                        </Typography>
                        <TextField
                          placeholder="Password"
                          id="Password"
                          fullWidth
                          size="small"
                          type={showPassword2 ? 'text' : 'password'}
                          value={password2}
                          onChange={handlePasswordChange}
                          error={Boolean(errorText)}
                          helperText={errorText}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={handleTogglePasswordVisibility2}>
                                  {showPassword2 ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography align="start" variant="body2">
                          Confirm Password
                        </Typography>
                        <TextField
                          placeholder="Confirm Password"
                          id="Confirm-Password"
                          size="small"
                          fullWidth
                          type={showPassword ? 'text' : 'password'}
                          value={confirmPassword}
                          onChange={handleConfirmPasswordChange}
                          error={Boolean(errorText2)}
                          helperText={errorText2}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={handleTogglePasswordVisibilities}>
                                  {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      {/* <Grid item xs={12}>
                        <Typography align="start" variant="body2">
                          Full Name
                        </Typography>
                        <TextField
                          placeholder="Full Name"
                          id="Fullname"
                          type="text"
                          fullWidth
                          size="small"
                          value={newfullname}
                          onChange={handleFullnameChange}
                          error={Boolean(errorTextFname)}
                          helperText={errorTextFname}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography align="start" variant="body2">
                          Phone Number
                        </Typography>
                        <TextField
                          size="small"
                          placeholder="Phone Number"
                          type="phone"
                          pattern="[0-9]*"
                          fullWidth
                          id="PhoneNumber"
                          value={newphone}
                          onChange={handlePhoneChange}
                          error={Boolean(errorphone)}
                          helperText={errorphone}
                        />
                      </Grid> */}

                      <Grid item xs={12} textAlign={'-webkit-center'}>
                        <Button
                          fullWidth
                          className="bg-blue-400 shadow-lg shadow-blue-500/50 text-white"
                          disabled={
                            loadings ||
                            password2 === '' ||
                            confirmPassword !== password2 ||
                            !/^(?=.*[A-Z])(?=.*\d).{7,}$/.test(password2)
                          }
                          type="submit"
                          variant="contained"
                          color="primary"
                        >
                          Submit
                        </Button>
                        <hr style={{ aligtenContent: 'center' }} className="mt-6 border-b-1 border-blueGray-300" />
                      </Grid>
                      {/* <Grid item xs={12}>
                        <Typography
                          align="center"
                          style={{ paddingTop: 10, color: 'rgba(0, 0, 0, 0.4)' }}
                          variant="body2"
                          fontWeight={'bold'}
                        >
                          Already have an account?{' '}
                          <a style={{ color: '#12A2CE' }} href="/">
                            Login
                          </a>
                        </Typography>
                      </Grid> */}
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </section>
    </form>
  );
}
const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};
